export class Paging {
    page_size: number = 15;
    page_number: number = 1;


}